import FileUpload from "../Common/FileUpload";
import ApiException from "../../types/ApiException";

interface FileUploadFieldProps {
  /* ─── UI/validation shared with other inputs ────────────────────────── */
  label: string;
  required?: boolean;
  err: ApiException | null;
  errField: string;

  /* ─── Props you already pass to <FileUpload /> ──────────────────────── */
  value?: File | null;                     // current file → decides if “Remove” is shown
  chooseButtonText: string;
  removeButtonText: string;
  acceptedFileTypes?: string;
  onFileChange: (f: File | null) => void;
  startIcon?: string;
  primary?: boolean;
  tertiary?: boolean;
  disabled?: boolean;
  className?: string;
  removeButtonClassName?: string; 
}

/**
 * A simple “form-field” wrapper around the existing <FileUpload/>.
 * It renders a label on top and decides whether the remove-button
 * should be visible based on `value`.
 */
const FileUploadField = ({
  label,
  required,
  value,
  err,
  errField,
  removeButtonClassName,
  ...fileUploadProps
}: FileUploadFieldProps) => {
  const showRemoveButton = value != null; // show “remove” only when a file is present

  return (
    <>
      <label>
        {required ? (
          <span className="bold">
            {label}:<span className="red">*</span>
          </span>
        ) : (
          `${label}:`
        )}
      </label>

      <FileUpload
        /* FileUpload’s own props */
        {...fileUploadProps}
        showRemoveButton={showRemoveButton}
        removeButtonClassName={removeButtonClassName}
        /* validation – we just forward these so FileUpload can render the message */
        err={err}
        errField={errField}
      />
    </>
  );
};

export default FileUploadField;